import ready from './lib/ready';
import promiseIdle from './lib/promise-idle';

import initFormFileFields from './lib/form-file-fields';
import initFormFieldError from './lib/form-field-error';
// import initFormWrappedFIelds from './lib/form-wrapped-fields';
// import initFormSteps from './lib/form-steps';

ready().then(promiseIdle()).then(function init() {
    initFormFileFields();
    initFormFieldError();
});